import React, { useEffect, useState } from "react";
import {
  getIdentificationType,
  isSuccessResponse,
  notFoundStatus,
  downloadFileFromURL,
} from "utils/helper";
import { useSelector } from "react-redux";
import makeRequest from "services/makeRequest";
import { routes } from "routes/apiRoutes";
import { IoMdClose } from "react-icons/io";
import { Loader, Typography, Modal, Radio } from "components";
import { fileBaseURL as baseURL } from "routes/routePaths";
// import axios from "axios";
import {
  setGuarantorsDetail,
  setUploadedDocs,
  inValidateUploadedDoc,
} from "redux/actions/onboardingActions";
import "./style.scss";

const Documents = ({ agentId, allowDocumentValidation }) => {
  const [loading, setLoading] = useState(false);
  const [imageToView, setImageToView] = useState(null);
  const { personalDetails, guarantorsDetail, uploadedDocs } = useSelector(
    (state) => state.onBoardingInfo
  );

  const {
    uploadedId,
    uploadedPassport,
    uploadedUtility,
    identificationType,
    identificationNumber,
    formC07,
    businessRegForm,
    uploadedUtilityExt,
    uploadedIdExt,
    uploadedPassportExt,
    uploadedFormExt,
    uploadedBusinessRegFormExt,
    uploadedUtilityFilename,
    uploadedIdFilename,
    uploadedPassportFilename,
    uploadedFormFilename,
    uploadedBusinessRegFormFileName,
  } = personalDetails || {};

  useEffect(() => {
    //In cases where admin clicks on the documents tab directly,
    //We do not have guarantor information yet in store so we get it
    //to extract document IDs
    const getAgentGuarantorDetails = async () => {
      setLoading(true);
      try {
        const { data } = await makeRequest(
          "get",
          routes.guarantorInfo(agentId)
        );

        if (isSuccessResponse(data)) {
          const guarantorsDetail = [...data.data];
          setGuarantorsDetail(guarantorsDetail);
        }

        setLoading(false);
      } catch (error) {
        if (notFoundStatus(error)) {
          setLoading(false);
        }
      }
    };
    !guarantorsDetail && getAgentGuarantorDetails();
  }, [agentId, guarantorsDetail]);

  const onClose = () => setImageToView(null);

  const showGuarantorDocs = () => {
    if (!guarantorsDetail) return false;

    if (guarantorsDetail[0]?.uploadedId || guarantorsDetail[0]?.uploadedForm)
      return true;

    return false;
  };

  // IMPLEMENTATION TO ALLOW FOR VALIDATING FOR INVALIDATING DOCS
  // First, all docs are said valid, therefore, radio btns are active
  // While ensuring that we have only items that agent had uploaded as a true value
  // Therefore, filter out undefined values

  const getUploadedDocsData = () => {
    //Api post key: Api get key
    let uploadedDocsData = {
      validId: uploadedId,
      validPassport: uploadedPassport,
      validUtility: uploadedUtility,
      validFormC07: formC07,
      validBusinessRegForm: businessRegForm,
    };

    if (guarantorsDetail) {
      uploadedDocsData = {
        ...uploadedDocsData,
        id: guarantorsDetail[0]?.id,
        validGuarantorId: guarantorsDetail[0]?.uploadedId,
        validGuarantorUploadedForm: guarantorsDetail[0]?.uploadedForm,
      };
    }

    return uploadedDocsData;
  };

  useEffect(() => {
    if (allowDocumentValidation) setUploadedDocs(getUploadedDocsData());

    //eslint-disable-next-line
  }, [guarantorsDetail]);

  const handleChange = (e) =>
    inValidateUploadedDoc(e.target.name, JSON.parse(e.target.value));

  if (loading)
    return (
      <div className="d-flex justify-content-center onboarding-loader">
        <Loader />
      </div>
    );

  return (
    <>
      <div className="row">
        {uploadedId && (
          <div className="col-md-4 mb-4">
            {allowDocumentValidation && (
              <div className="text-center">
                <Radio
                  checked={uploadedDocs.validId}
                  checkedState="secondary"
                  label="Valid"
                  labelPosition="before"
                  name="validId"
                  value={true}
                  onClick={handleChange}
                />
                <Radio
                  checked={!uploadedDocs.validId}
                  checkedState="secondary"
                  label="Invalid"
                  labelPosition="before"
                  name="validId"
                  value={false}
                  onClick={handleChange}
                />
              </div>
            )}
            {/* <p>5</p> */}
            <div className="uploaded-file">
              <img
                src={`${baseURL}/${uploadedId}`}
                alt=""
                width="100%"
                height="80%"
              />
              <div className="text-center">
                <a
                  href={`${baseURL}/${uploadedId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Typography variant="caption2" className={"cursor-pointer"}>
                    View
                  </Typography>
                </a>
                <Typography
                  variant="caption2"
                  className={"cursor-pointer ml-4"}
                  onClick={() =>
                    downloadFileFromURL(
                      `${baseURL}/${uploadedId}`,
                      uploadedIdExt,
                      uploadedIdFilename
                    )
                  }
                >
                  Download
                </Typography>
              </div>
            </div>
            <div className="uploaded-file-details mt-3 d-flex flex-column justify-content-center align-items-center">
              <Typography variant="body2">
                Identification Type:{" "}
                {getIdentificationType(identificationType)?.label}
              </Typography>
              <Typography variant="body2">
                Identification Number: {identificationNumber}
              </Typography>
            </div>
          </div>
        )}

        {uploadedPassport && (
          <div className="col-md-4 mb-4">
            {allowDocumentValidation && (
              <div className="text-center">
                <Radio
                  checked={uploadedDocs.validPassport}
                  checkedState="secondary"
                  label="Valid"
                  labelPosition="before"
                  name="validPassport"
                  value={true}
                  onClick={handleChange}
                />
                <Radio
                  checked={!uploadedDocs.validPassport}
                  checkedState="secondary"
                  label="Invalid"
                  labelPosition="before"
                  name="validPassport"
                  value={false}
                  onClick={handleChange}
                />
              </div>
            )}
            <div className="uploaded-file">
              <img
                src={`${baseURL}/${uploadedPassport}`}
                alt=""
                width="100%"
                height="80%"
              />
              <div className="">
                <a
                  href={`${baseURL}/${uploadedPassport}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Typography
                    variant="caption2"
                    className={"cursor-pointer mr-4"}
                  >
                    View
                  </Typography>
                </a>

                <Typography
                  variant="caption2"
                  className={"cursor-pointer ml-4"}
                  onClick={() =>
                    downloadFileFromURL(
                      `${baseURL}/${uploadedPassport}`,
                      uploadedPassportExt,
                      uploadedPassportFilename
                    )
                  }
                >
                  Download
                </Typography>
              </div>
            </div>
            <Typography variant="body2" className={"text-center mt-4"}>
              Passport
            </Typography>
          </div>
        )}

        {uploadedUtility && (
          <div className="col-md-4 mb-4">
            {allowDocumentValidation && (
              <div className="text-center">
                <Radio
                  checked={uploadedDocs.validUtility}
                  checkedState="secondary"
                  label="Valid"
                  labelPosition="before"
                  name="validUtility"
                  value={true}
                  onClick={handleChange}
                />
                <Radio
                  checked={!uploadedDocs.validUtility}
                  checkedState="secondary"
                  label="inValid"
                  labelPosition="before"
                  name="validUtility"
                  value={false}
                  onClick={handleChange}
                />
              </div>
            )}
            <div className="uploaded-file">
              <img
                src={`${baseURL}/${uploadedUtility}`}
                alt=""
                width="100%"
                height="80%"
              />
              <div className="">
                <a
                  href={`${baseURL}/${uploadedUtility}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Typography variant="caption2" className={"cursor-pointer"}>
                    View
                  </Typography>
                </a>
                <Typography
                  variant="caption2"
                  className={"cursor-pointer ml-4"}
                  onClick={() =>
                    downloadFileFromURL(
                      `${baseURL}/${uploadedUtility}`,
                      uploadedUtilityExt,
                      uploadedUtilityFilename
                    )
                  }
                >
                  Download
                </Typography>
              </div>
            </div>
            <Typography variant="body2" className={"text-center mt-4"}>
              Utility Bill
            </Typography>
          </div>
        )}

        {formC07 && (
          <div className="col-md-4 mb-4">
            {allowDocumentValidation && (
              <div className="text-center">
                <Radio
                  checked={uploadedDocs.validFormC07}
                  checkedState="secondary"
                  label="Valid"
                  labelPosition="before"
                  name="validFormC07"
                  value={true}
                  onClick={handleChange}
                />
                <Radio
                  checked={!uploadedDocs.validFormC07}
                  checkedState="secondary"
                  label="Invalid"
                  labelPosition="before"
                  name="validFormC07"
                  value={false}
                  onClick={handleChange}
                />
              </div>
            )}
            <div className="uploaded-file">
              <img
                src={`${baseURL}/${formC07}`}
                alt=""
                width="100%"
                height="80%"
              />
              <div className="">
                <a
                  href={`${baseURL}/${formC07}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Typography variant="caption2" className={"cursor-pointer"}>
                    View
                  </Typography>
                </a>
                <Typography
                  variant="caption2"
                  className={"cursor-pointer ml-4"}
                  onClick={() =>
                    downloadFileFromURL(
                      `${baseURL}/${formC07}`,
                      uploadedFormExt,
                      uploadedFormFilename
                    )
                  }
                >
                  Download
                </Typography>
              </div>
            </div>
            <Typography variant="body2" className={"text-center mt-4"}>
              Corporate’s form C07
            </Typography>
          </div>
        )}

        {businessRegForm && (
          <div className="col-md-4 mb-4">
            {allowDocumentValidation && (
              <div className="text-center">
                <Radio
                  checked={uploadedDocs.validBusinessRegForm}
                  checkedState="secondary"
                  label="Valid"
                  labelPosition="before"
                  name="validBusinessRegForm"
                  value={true}
                  onClick={handleChange}
                />
                <Radio
                  checked={!uploadedDocs.validBusinessRegForm}
                  checkedState="secondary"
                  label="Invalid"
                  labelPosition="before"
                  name="validBusinessRegForm"
                  value={false}
                  onClick={handleChange}
                />
              </div>
            )}
            <div className="uploaded-file">
              <img
                src={`${baseURL}/${businessRegForm}`}
                alt=""
                width="100%"
                height="80%"
              />
              <div className="">
                <a
                  href={`${baseURL}/${businessRegForm}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Typography variant="caption2" className={"cursor-pointer"}>
                    View
                  </Typography>
                </a>
                <Typography
                  variant="caption2"
                  className={"cursor-pointer ml-4"}
                  onClick={() =>
                    downloadFileFromURL(
                      `${baseURL}/${businessRegForm}`,
                      uploadedBusinessRegFormExt,
                      uploadedBusinessRegFormFileName
                    )
                  }
                >
                  Download
                </Typography>
              </div>
            </div>
            <Typography variant="body2" className={"text-center mt-4"}>
              Business Registration Form/CAC
            </Typography>
          </div>
        )}
      </div>

      <div className="row mt-4">
        {showGuarantorDocs() && (
          <Typography state="primary" className="mt-4" variant={"subtitle1"}>
            Guarantor Documents
          </Typography>
        )}
        {/* {(guarantorsDetail && guarantorsDetail[0]?.uploadedId) ||
          (guarantorsDetail && guarantorsDetail[0]?.uploadedForm  (
            <Typography state="primary" className="mt-4" variant={"subtitle1"}>
              Guarantor Documents
            </Typography>
          ))} */}
        {guarantorsDetail && guarantorsDetail[0]?.uploadedId && (
          <div className="col-md-4 mb-4">
            {allowDocumentValidation && (
              <div className="text-center">
                <Radio
                  checked={uploadedDocs.validGuarantorId}
                  checkedState="secondary"
                  label="Valid"
                  labelPosition="before"
                  name="validGuarantorId"
                  value={true}
                  onClick={handleChange}
                />
                <Radio
                  checked={!uploadedDocs.validGuarantorId}
                  checkedState="secondary"
                  label="inValid"
                  labelPosition="before"
                  name="validGuarantorId"
                  value={false}
                  onClick={handleChange}
                />
              </div>
            )}
            <div className="uploaded-file">
              <img
                src={`${baseURL}/${guarantorsDetail[0]?.uploadedId}`}
                alt=""
                width="100%"
                height="80%"
              />
              <div className="">
                <a
                  href={`${baseURL}/${guarantorsDetail[0]?.uploadedId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Typography variant="caption2" className={"cursor-pointer"}>
                    View
                  </Typography>
                </a>
                <Typography
                  variant="caption2"
                  className={"cursor-pointer ml-4"}
                  onClick={() =>
                    downloadFileFromURL(
                      `${baseURL}/${guarantorsDetail[0]?.uploadedId}`,
                      guarantorsDetail[0]?.uploadedIdExt,
                      guarantorsDetail[0]?.uploadedIdFilename
                    )
                  }
                >
                  Download
                </Typography>
              </div>
            </div>
            <div className="uploaded-file-details mt-3 d-flex flex-column justify-content-center align-items-center">
              <Typography variant="body2">
                Identification Type:{" "}
                {
                  getIdentificationType(guarantorsDetail[0]?.identificationType)
                    ?.label
                }
              </Typography>
              <Typography variant="body2">
                Identification Number:{" "}
                {guarantorsDetail[0]?.identificationNumber}
              </Typography>
            </div>
          </div>
        )}

        {guarantorsDetail && guarantorsDetail[0]?.uploadedForm && (
          <div className="col-md-4 mb-4">
            {allowDocumentValidation && (
              <div className="text-center">
                <Radio
                  checked={uploadedDocs.validGuarantorUploadedForm}
                  checkedState="secondary"
                  label="Valid"
                  labelPosition="before"
                  name="validGuarantorUploadedForm"
                  value={true}
                  onClick={handleChange}
                />
                <Radio
                  checked={!uploadedDocs.validGuarantorUploadedForm}
                  checkedState="secondary"
                  label="inValid"
                  labelPosition="before"
                  name="validGuarantorUploadedForm"
                  value={false}
                  onClick={handleChange}
                />
              </div>
            )}
            <div className="uploaded-file">
              <img
                src={`${baseURL}/${guarantorsDetail[0]?.uploadedForm}`}
                alt=""
                width="100%"
                height="80%"
              />
              <div className="">
                <a
                  href={`${baseURL}/${guarantorsDetail[0]?.uploadedForm}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Typography variant="caption2" className={"cursor-pointer"}>
                    View
                  </Typography>
                </a>
                <Typography
                  variant="caption2"
                  className={"cursor-pointer ml-4"}
                  onClick={() =>
                    downloadFileFromURL(
                      `${baseURL}/${guarantorsDetail[0]?.uploadedForm}`,
                      guarantorsDetail[0]?.uploadedFormExt,
                      guarantorsDetail[0]?.uploadedFormFilename
                    )
                  }
                >
                  Download
                </Typography>
              </div>
            </div>
            <Typography variant="body2" className={"text-center mt-4"}>
              Guarantor form{" "}
            </Typography>
          </div>
        )}
      </div>
      <Modal showModal={!!imageToView} onClose={onClose}>
        <div className="my-4">
          <div className="d-flex justify-content-end">
            <IoMdClose className="cursor-pointer" onClick={onClose} />
          </div>
          <div className="mt-3">
            <img src={imageToView} width="100%" alt="" />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Documents;
